// work around eslint error "jsx-no-bind"
export default function partialBind(fn, ...args) {
  return fn.bind(...args);
}
